var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSpinner)?_c('div',{class:_vm.full ? 'Spinner__full' : 'Spinner'},[_c('b-spinner',{attrs:{"variant":_vm.variant,"label":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }